import React, { useEffect } from "react";
import { X } from "lucide-react";

export function Modal({ open, onClose, title, children, testid }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
    window.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { window.removeEventListener("keydown", onKey); document.body.style.overflow = prev; };
  }, [open, onClose]);
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[9998] grid place-items-center p-4" data-testid={testid}>
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative w-full max-w-lg tt-panel-3 rounded-2xl p-5 tt-rise max-h-[90vh] overflow-y-auto tt-scroll">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-display text-2xl text-white">{title}</h3>
          <button onClick={onClose} aria-label="Close" className="w-8 h-8 grid place-items-center rounded-lg text-white/60 hover:text-white hover:bg-white/5"><X size={18} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function TextField({ label, ...props }) {
  return (
    <label className="block mb-3">
      <span className="block text-sm text-white/70 mb-1">{label}</span>
      <input {...props} className="w-full h-10 bg-[#10151D] border border-[#2A3544] rounded-lg px-3 text-sm text-white placeholder:text-white/30 focus:border-[#2F7D32] outline-none" />
    </label>
  );
}

export function SelectField({ label, children, ...props }) {
  return (
    <label className="block mb-3">
      <span className="block text-sm text-white/70 mb-1">{label}</span>
      <select {...props} className="w-full h-10 bg-[#10151D] border border-[#2A3544] rounded-lg px-3 text-sm text-white focus:border-[#2F7D32] outline-none">
        {children}
      </select>
    </label>
  );
}

export function TextArea({ label, ...props }) {
  return (
    <label className="block mb-3">
      <span className="block text-sm text-white/70 mb-1">{label}</span>
      <textarea {...props} className="w-full min-h-[80px] bg-[#10151D] border border-[#2A3544] rounded-lg px-3 py-2 text-sm text-white placeholder:text-white/30 focus:border-[#2F7D32] outline-none" />
    </label>
  );
}
